import React from 'react';
import Logo from './Logo';

export default function SiteFooter() {
  return (
    <footer style={{ background: 'var(--bg)', borderTop: '1px solid var(--border)', padding: '48px 32px' }}>
      <div style={{ maxWidth: 1280, margin: '0 auto', display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 24, alignItems: 'center' }}>
        <Logo height={28} />
        <div style={{ fontFamily: 'var(--font-mono)', fontSize: 11, letterSpacing: '0.12em', color: 'var(--fg-muted)' }}>
          [ THE UNC · {new Date().getFullYear()} · ™ Code Struct Inc ]
        </div>
        <div style={{ display: 'flex', gap: 24, fontSize: 13, color: 'var(--fg-muted)' }}>
          <a
            href="https://www.termsfeed.com/live/47bc3ca0-9ac1-4150-a824-3c2346820d3e"
            target="_blank"
            rel="noopener noreferrer"
            style={{ cursor: 'pointer' }}
          >
            Privacy Policy
          </a>
          <a
            href="https://www.termsfeed.com/live/e99bdf53-4385-421f-b2de-afaf75354436"
            target="_blank"
            rel="noopener noreferrer"
            style={{ cursor: 'pointer' }}
          >
            Terms & Conditions
          </a>
        </div>
      </div>
    </footer>
  );
}
